export class NavBarLink{
	url: string;
	caption: string;
	constructor(data:any){
		if(data['caption']){
			this.caption = data['caption'];
		}
		if(data['url']){
			this.url = data['url'];
		}
	}
	public getUrl(){
		return this.url;		
	}
	public getCaption(){
		return this.caption;
	}
}